// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__0H6Il","checkmark":"Checkbox_checkmark__0wx-Z","disabled":"Checkbox_disabled__3HXlT"};